import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Advertisement from "./Advertisement";
import type TvCaptionFragment from "./TvCaptionFragment";

@Model()
class AdvertisementFragment extends ApplicationRecord {
  static jsonapiType = "advertisement_fragments";

  @BelongsTo() advertisment: Advertisement;

  @Attr({ persist: false }) createdAt: string;

  @Attr() text: string;

  @Attr() timestamp: number;

  @BelongsTo() tvCaptionFragment: TvCaptionFragment;

  @Attr({ persist: false }) updatedAt: string;
}

export default AdvertisementFragment;
